import React from "react"
import styled from "styled-components"

const PageTitle = styled.h3`
  font-weight: normal;
  font-size: 28px;
  margin: 24px 0 0 0;
`

const HrStyled = styled.hr`
  margin-top: -4px;
`

export default function pageHeader({ children }) {
  return (
    <>
      <PageTitle>{children}</PageTitle>
      <HrStyled />
    </>
  )
}
